/**
 * C1 — registro do service worker em produção.
 *
 * Workbox GenerateSW grava `/service-worker.js` no build. Registramos
 * com `scope: "/"` (default) e, quando detectamos um SW em `waiting`
 * (= nova versão pronta), disparamos um evento `nexo-sw-update` no
 * window pra o componente `<UpdateAvailable>` mostrar o banner.
 *
 * Mantemos a referência da registration em `window.__nexoSWRegistration`
 * pra que componentes que montem TARDE ainda consigam acessar.
 */

export function registerServiceWorker() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  // Espera load pra não competir com bootstrap do app.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        window.__nexoSWRegistration = registration;

        // Se já existir SW em waiting no carregamento (ex.: refresh
        // depois de deploy enquanto a aba estava fechada), dispara
        // o evento imediatamente.
        if (registration.waiting) {
          window.dispatchEvent(
            new CustomEvent("nexo-sw-update", { detail: { registration } })
          );
        }

        // Quando um SW novo é encontrado (updatefound), observamos seu
        // ciclo de vida; quando ele entra em "installed" e já existe um
        // controller (= já tinha SW antes), significa "nova versão".
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              window.dispatchEvent(
                new CustomEvent("nexo-sw-update", { detail: { registration } })
              );
            }
          });
        });
      })
      .catch((err) => {
        // Falha de registro não é fatal — app segue funcionando como
        // web app normal. Loga em console pra debug.
        // eslint-disable-next-line no-console
        console.warn("[pwa] service worker registration failed:", err);
      });
  });
}
